var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertBuiltCampaignComponentResponseToBuiltComponentResponse } from "../../../shared/convert/convertBuiltCampaignComponentResponseToBuiltComponentResponse";
export function loadAndEmitCampaignState(campaignId, inboundEventBus, campaignEndpoints, campaignSummaryEndpoints) {
    return __awaiter(this, void 0, void 0, function* () {
        const builtCampaignPromise = Promise.resolve(campaignEndpoints.getBuiltCampaign(campaignId));
        const campaignSummaryPromise = Promise.resolve(campaignSummaryEndpoints.getCampaignSummary(campaignId));
        builtCampaignPromise
            .then((builtCampaign) => {
            inboundEventBus.emit("built_campaign_updated", { builtCampaign });
            builtCampaign.components.forEach((component) => {
                inboundEventBus.emit("built_component_updated", {
                    builtComponent: convertBuiltCampaignComponentResponseToBuiltComponentResponse(campaignId, builtCampaign.state, component),
                });
            });
        })
            .catch(() => { });
        campaignSummaryPromise
            .then((campaignSummary) => {
            inboundEventBus.emit("campaign_summary_updated", {
                campaignSummary,
            });
        })
            .catch(() => { });
        yield Promise.all([builtCampaignPromise, campaignSummaryPromise]);
    });
}
